module.exports = __webpack_public_path__ + "static/cabina-conductor---tablero-de-control-ddaa9e212d021ad008cc48d2f640651b.jpg";